import basicLineChartInit from './examples/basic-line-chart';
import basicAreaLineChartInit from './examples/area-line-chart';
import stackedLineChartInit from './examples/stacked-line-chart';
import stackedAreaChartInit from './examples/stacked-area-chart';
import lineMarkerChartInit from './examples/line-marker-chart';
import areaPiecesChartInit from './examples/area-pieces-chart';
import stepLineChartInit from './examples/step-line-chart';
import lineGradientChartInit from './examples/line-gradient-chart';
import dynamicLineChartInit from './examples/dynamic-line-chart';
import lineLogChartInit from './examples/line-log-chart';
import shareDatasetChartInit from './examples/share-dataset-chart';
import basicBarChartInit from './examples/basic-bar-chart';
import horizontalBarChartInit from './examples/horizontal-bar-chart';
import barNegativeChartInit from './examples/bar-negative-chart';
import seriesBarChartInit from './examples/series-bar-chart';
import stackedBarChartInit from './examples/stacked-bar-chart';
import stackedHorizontalBarChartInit from './examples/stacked-horizontal-bar-chart';
import barRaceChartInit from './examples/bar-race-chart';
import barGradientChartInit from './examples/bar-gradient-chart';
import barLineMixedChartInit from './examples/bar-line-mixed-chart';
import barWaterFallChartInit from './examples/bar-waterfall-chart';
import barTimelineChartInit from './examples/bar-timeline-chart';
import basicCandlestickChartInit from './examples/basic-candlestick-chart';
import candlestickMixedChartInit from './examples/candlestick-mixed-chart';
import sessionByCountryMapInit from './examples/session-by-country-map';
import mapUSAInit from './examples/map-usa';
import basicScatterChartInit from './examples/basic-scatter-chart';
import bubbleChartInit from './examples/bubble-chart';
import quartetScatterChartInit from './examples/quartet-scatter-chart';
import singleAxisScatterChartInit from './examples/single-axis-scatter-chart';
import pieChartInit from './examples/pie-chart';
import doughnutChartInit from './examples/doughnut-chart';
import doughnutRoundedChartInit from './examples/doughnut-rounded-chart';
import pieMultipleChartInit from './examples/pie-multiple-chart';
import pieLabelAlignChartInit from './examples/pie-label-align-chart';
import pieEdgeAlignChartInit from './examples/pie-edge-align-chart';
import basicGaugeChartInit from './examples/basic-gauge-chart';
import gaugeProgressChartInit from './examples/gauge-progress-chart';
import gaugeRingChartInit from './examples/gauge-ring-chart';
import gaugeMultiRingChartInit from './examples/gauge-multi-ring-chart';
import gaugeMultiTitleChartInit from './examples/gauge-multi-title-chart';
import gaugeGradeChartInit from './examples/gauge-grade-chart';
import radarChartInit from './examples/radar-chart';
import radarCustomizedChartInit from './examples/radar-customized-chart';
import radarMultipleChartInit from './examples/radar-multiple-chart';
import heatmapChartInit from './examples/heatmap-chart';
import heatmapSingleSeriesChartInit from './examples/heatmap-single-series-chart';

const { docReady } = window.phoenix.utils;

docReady(basicLineChartInit);
docReady(basicAreaLineChartInit);
docReady(stackedLineChartInit);
docReady(stackedAreaChartInit);
docReady(lineMarkerChartInit);
docReady(areaPiecesChartInit);
docReady(stepLineChartInit);
docReady(lineGradientChartInit);
docReady(dynamicLineChartInit);
docReady(lineLogChartInit);
docReady(shareDatasetChartInit);
docReady(basicBarChartInit);
docReady(horizontalBarChartInit);
docReady(barNegativeChartInit);
docReady(seriesBarChartInit);
docReady(stackedBarChartInit);
docReady(stackedHorizontalBarChartInit);
docReady(barRaceChartInit);
docReady(barGradientChartInit);
docReady(barLineMixedChartInit);
docReady(barWaterFallChartInit);
docReady(barTimelineChartInit);
docReady(basicCandlestickChartInit);
docReady(candlestickMixedChartInit);
docReady(sessionByCountryMapInit);
docReady(mapUSAInit);
docReady(basicScatterChartInit);
docReady(bubbleChartInit);
docReady(quartetScatterChartInit);
docReady(singleAxisScatterChartInit);
docReady(pieChartInit);
docReady(doughnutChartInit);
docReady(doughnutRoundedChartInit);
docReady(pieMultipleChartInit);
docReady(pieLabelAlignChartInit);
docReady(pieEdgeAlignChartInit);
docReady(basicGaugeChartInit);
docReady(gaugeProgressChartInit);
docReady(gaugeRingChartInit);
docReady(gaugeMultiRingChartInit);
docReady(gaugeMultiTitleChartInit);
docReady(gaugeGradeChartInit);
docReady(radarChartInit);
docReady(radarCustomizedChartInit);
docReady(radarMultipleChartInit);
docReady(heatmapChartInit);
docReady(heatmapSingleSeriesChartInit);
